var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { getTranslation } from '../../translation';
// @ts-ignore
var ErrorDialog = /** @class */ (function (_super) {
    __extends(ErrorDialog, _super);
    function ErrorDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOk = function () {
            _this.props.onClose();
        };
        return _this;
    }
    ErrorDialog.prototype.render = function () {
        var _a = this.props, message = _a.message, translate = _a.translate, other = __rest(_a, ["message", "translate"]);
        return (React.createElement(Dialog, __assign({ disableBackdropClick: true, disableEscapeKeyDown: true, maxWidth: "md", "aria-labelledby": "error-dialog" }, other),
            React.createElement(DialogTitle, { id: "error-dialog" }, translate('error')),
            React.createElement(DialogContent, null,
                React.createElement("p", null, message)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { name: "Ok", id: "error-dialog-okay-btn", onClick: this.handleOk, color: "primary" }, "Ok"))));
    };
    ErrorDialog = __decorate([
        connect(function (state, ownProps) {
            return __assign(__assign({}, ownProps), { translate: getTranslation(state.translation.lang) });
        }, null)
    ], ErrorDialog);
    return ErrorDialog;
}(React.PureComponent));
export { ErrorDialog };



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/ErrorDialog.tsx
// module id = 263
// module chunks = 81